module.exports = __webpack_public_path__ + "fonts/Open_Sans-400-vietnamese16.5ec64a9.woff2";